(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newbloom-ingredients-cles"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('nb-key-ingredients')) return;

  class NBKeyIngredients extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.controller) this.controller.abort();
    }

    initialize() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.tabs = Array.from(this.querySelectorAll('[data-nbki-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-nbki-panel]'));
      this.rows = Array.from(this.querySelectorAll('[data-nbki-row]'));
      this.tablist = this.querySelector('[data-nbki-tabs]');
      if (!this.tablist || !this.tabs.length) return;

      this.setAttribute('data-enhanced', '');
      this.tablist.setAttribute('role', 'tablist');
      this.media = matchMedia('(max-width: 749px)');
      const updateOrientation = () => {
        this.tablist.setAttribute('aria-orientation', this.media.matches ? 'horizontal' : 'vertical');
      };
      updateOrientation();
      this.media.addEventListener('change', updateOrientation, { signal });

      this.tabs.forEach((tab) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.hash.slice(1));
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          this.activate(tab.dataset.nbkiTab);
        }, { signal });
        tab.addEventListener('keydown', (event) => {
          const isVertical = !this.media.matches;
          const nextKey = isVertical ? 'ArrowDown' : 'ArrowRight';
          const previousKey = isVertical ? 'ArrowUp' : 'ArrowLeft';
          let target = this.tabs.indexOf(tab);
          if (event.key === nextKey) target = (target + 1) % this.tabs.length;
          else if (event.key === previousKey) target = (target - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = this.tabs.length - 1;
          else if (event.key === ' ') {
            event.preventDefault();
            this.activate(tab.dataset.nbkiTab);
            return;
          } else return;
          event.preventDefault();
          this.activate(this.tabs[target].dataset.nbkiTab, true);
        }, { signal });
      });
      this.panels.forEach((panel) => {
        panel.setAttribute('role', 'tabpanel');
        panel.tabIndex = 0;
      });
      this.rows.forEach((row) => {
        row.addEventListener('toggle', () => {
          if (!row.open || this.dataset.singleOpen !== 'true') return;
          const parentPanel = row.closest('[data-nbki-panel]');
          this.rows.forEach((other) => {
            if (other !== row && other.closest('[data-nbki-panel]') === parentPanel) other.open = false;
          });
        }, { signal });
      });
      this.addEventListener('shopify:block:select', (event) => {
        const row = this.rows.find((item) => item.dataset.blockId === String(event.detail?.blockId));
        if (!row) return;
        const panel = row.closest('[data-nbki-panel]');
        if (panel) this.activate(panel.dataset.nbkiPanel);
        row.open = true;
        requestAnimationFrame(() => {
          if (row.isConnected) row.scrollIntoView({ block: 'nearest', behavior: 'auto' });
        });
      }, { signal });
      this.activate(this.dataset.defaultGroup || this.tabs[0].dataset.nbkiTab);
    }

    activate(group, moveFocus = false) {
      const target = this.tabs.find((tab) => tab.dataset.nbkiTab === group) || this.tabs[0];
      if (!target) return;
      group = target.dataset.nbkiTab;
      this.tabs.forEach((tab) => {
        const selected = tab === target;
        tab.dataset.selected = String(selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.nbkiPanel !== group; });
      if (moveFocus) target.focus({ preventScroll: true });
      if (this.media.matches) {
        const offset = target.offsetLeft - this.tablist.offsetLeft;
        if (offset < this.tablist.scrollLeft) this.tablist.scrollLeft = offset;
        else if (offset + target.offsetWidth > this.tablist.scrollLeft + this.tablist.clientWidth) {
          this.tablist.scrollLeft = offset + target.offsetWidth - this.tablist.clientWidth;
        }
      }
    }
  }
  customElements.define('nb-key-ingredients', NBKeyIngredients);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newbloom-offers"] && !Shopify.designMode) return;
  try {
    
/* Newbloom offers v2.0 — quantité + fréquence + prix/paquet + prix barré CTA */
(() => {
  'use strict';

  if (customElements.get('newbloom-offers')) return;

  const escape = (s) => String(s ?? '').replace(/[&<>"']/g, c => ({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
  }[c]));

  const lines = s => String(s || '').split(/\r?\n/).map(x => x.trim()).filter(Boolean);

  class NewbloomOffers extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      queueMicrotask(() => this.start());
    }

    disconnectedCallback() {
      queueMicrotask(() => { if (!this.isConnected) this.cleanup(); });
    }

    start() {
      try {
        this.data = JSON.parse(this.querySelector('[data-config]').textContent);
        this.c = this.data.settings;
        this.main = this.data.product;
        this.partnerProduct = this.data.partner;
        this.money = n => new Intl.NumberFormat(this.data.locale || 'fr-FR', {
          style: 'currency',
          currency: this.data.currency || 'EUR'
        }).format((Number(n) || 0) / 100);

        this.abort = new AbortController();
        this.offers = this.data.offers.map(o => this.resolve(o));
        this.monthOffer = this.offers.find(o => o.key === 'month') || null;
        this.quarterOffer = this.offers.find(o => o.key === 'quarter') || null;
        this.onceOffer = this.offers.find(o => o.key === 'once') || null;

        if (!this.monthOffer && !this.quarterOffer && !this.onceOffer) {
          throw new Error('Aucune offre Newbloom configurée.');
        }

        this.duration = this.c.default_offer === 'quarter' ? 3 : 1;
        this.mode = this.c.default_offer === 'once' ? 'once' : 'sub';

        if (!this.mainSelection(this.duration, this.mode).valid) {
          const fallback = [
            [3, 'sub'],
            [1, 'sub'],
            [3, 'once'],
            [1, 'once']
          ].find(([d, m]) => this.mainSelection(d, m).valid);
          if (!fallback) throw new Error('Aucune combinaison quantité / fréquence disponible.');
          [this.duration, this.mode] = fallback;
        }

        this.duo = this.c.default_partner === 'yes' && this.eligible();

        this.render();
        this.mount();

        this.addEventListener('click', e => {
          const duration = e.target.closest('[data-duration]')?.dataset.duration;
          const mode = e.target.closest('[data-mode]')?.dataset.mode;
          const action = e.target.closest('[data-action]')?.dataset.action;

          if (duration) {
            const next = Number(duration);
            if (this.mainSelection(next, this.mode).valid) {
              this.duration = next;
            } else {
              const alt = this.mode === 'sub' ? 'once' : 'sub';
              if (this.mainSelection(next, alt).valid) {
                this.duration = next;
                this.mode = alt;
              }
            }
            if (!this.eligible()) this.duo = false;
            this.refresh();
            return;
          }

          if (mode) {
            if (this.mainSelection(this.duration, mode).valid) {
              this.mode = mode;
              if (!this.eligible()) this.duo = false;
              this.refresh();
            }
            return;
          }

          if (action === 'yes' || action === 'no') {
            this.duo = action === 'yes';
            this.refresh();
            return;
          }

          if (action === 'why') {
            this.previousOverflow = document.body.style.overflow;
            this.dialog.showModal();
            document.body.style.overflow = 'hidden';
            return;
          }

          if (action === 'close') {
            this.dialog.close();
            return;
          }

          if (action === 'add') this.add();
        }, { signal: this.abort.signal });

        this.dialog = this.querySelector('dialog');
        this.dialog.addEventListener('close', () => {
          document.body.style.overflow = this.previousOverflow ?? '';
        }, { signal: this.abort.signal });

        this.dialog.addEventListener('click', e => {
          if (e.target === this.dialog && e.clientX < this.dialog.getBoundingClientRect().left) {
            this.dialog.close();
          }
        }, { signal: this.abort.signal });

        const tip = this.querySelector('[data-tip]');
        if (tip) {
          tip.querySelector('summary').addEventListener('click', e => {
            e.preventDefault();
            this.tipPinned = !this.tipPinned;
            tip.open = this.tipPinned;
          }, { signal: this.abort.signal });

          tip.addEventListener('pointerenter', e => {
            if (e.pointerType === 'mouse') tip.open = true;
          }, { signal: this.abort.signal });

          tip.addEventListener('pointerleave', () => {
            if (!this.tipPinned) tip.open = false;
          }, { signal: this.abort.signal });

          document.addEventListener('pointerdown', e => {
            if (!tip.contains(e.target)) {
              tip.open = false;
              this.tipPinned = false;
            }
          }, { signal: this.abort.signal });

          document.addEventListener('keydown', e => {
            if (e.key === 'Escape') {
              tip.open = false;
              this.tipPinned = false;
            }
          }, { signal: this.abort.signal });
        }

        this.refresh();
        this.hidden = false;
      } catch (error) {
        this.cleanup();
        console.error('[Newbloom offers]', error);
        if (window.Shopify?.designMode) {
          this.hidden = false;
          this.textContent = 'Offres Newbloom : ' + error.message;
        }
      }
    }

    resolve(o) {
      const variant = this.main.variants.find(v => String(v.id) === String(o.variant_id)) ||
        (!o.variant_id ? this.main.variants[0] : null);
      const allocation = variant?.plans.find(p => String(p.id) === String(o.plan_id));
      const qty = Math.max(1, Number(o.quantity) || 1);
      const valid = !!variant?.available && this.quantityValid(variant, qty) &&
        (o.key === 'once' ? !variant.requiresPlan : !!allocation?.recurring);

      return {
        ...o,
        variant,
        allocation,
        qty,
        valid,
        unit: o.key === 'once' ? variant?.price : allocation?.price
      };
    }

    quantityValid(v, n) {
      return n >= (v.min || 1) &&
        (!v.max || n <= v.max) &&
        (n - (v.min || 1)) % (v.increment || 1) === 0;
    }

    baseUnit() {
      return this.onceOffer?.variant?.price ||
        this.monthOffer?.variant?.price ||
        this.quarterOffer?.variant?.price || 0;
    }

    offerForDuration(duration) {
      return Number(duration) === 3 ? this.quarterOffer : this.monthOffer;
    }

    mainSelection(duration = this.duration, mode = this.mode) {
      duration = Number(duration) === 3 ? 3 : 1;

      if (mode === 'sub') {
        const o = this.offerForDuration(duration);
        if (!o?.variant || !o?.allocation?.recurring) {
          return { valid: false, message: this.c.unavailable_text };
        }
        const qty = Math.max(1, Number(o.qty) || duration);
        const valid = !!o.variant.available && this.quantityValid(o.variant, qty);
        return {
          valid,
          message: valid ? '' : this.c.unavailable_text,
          offer: o,
          variant: o.variant,
          allocation: o.allocation,
          qty,
          unit: o.allocation.price,
          total: o.allocation.price * qty,
          item: {
            id: String(o.variant.id),
            quantity: qty,
            selling_plan: String(o.allocation.id)
          }
        };
      }

      if (duration === 1) {
        const o = this.onceOffer;
        if (!o?.variant) return { valid: false, message: this.c.unavailable_text };
        const qty = Math.max(1, Number(o.qty) || 1);
        const valid = !!o.variant.available && !o.variant.requiresPlan && this.quantityValid(o.variant, qty);
        return {
          valid,
          message: valid ? '' : this.c.unavailable_text,
          offer: o,
          variant: o.variant,
          allocation: null,
          qty,
          unit: o.variant.price,
          total: o.variant.price * qty,
          item: { id: String(o.variant.id), quantity: qty }
        };
      }

      const preferred = this.quarterOffer?.variant;
      const fallback = this.onceOffer?.variant;
      const variant = preferred?.available && !preferred.requiresPlan ? preferred : fallback;
      const qty = this.quarterOffer?.qty || 3;
      const valid = !!variant?.available && !variant.requiresPlan && this.quantityValid(variant, qty);

      return {
        valid,
        message: valid ? '' : this.c.unavailable_text,
        offer: this.quarterOffer || this.onceOffer,
        variant,
        allocation: null,
        qty,
        unit: variant?.price || 0,
        total: (variant?.price || 0) * qty,
        item: valid ? { id: String(variant.id), quantity: qty } : null
      };
    }

    eligible() {
      return !!this.c.partner_enabled &&
        !!this.partnerProduct?.id &&
        (!this.c.partner_subscription_only || this.mode !== 'once');
    }

    partnerVariantFor(mainSelection) {
      const o = mainSelection.offer || this.offerForDuration(this.duration) || this.onceOffer;
      return this.partnerProduct?.variants?.find(v => String(v.id) === String(o?.partner_variant_id)) ||
        (!o?.partner_variant_id ? this.partnerProduct?.variants?.[0] : null) ||
        this.partnerProduct?.variants?.[0] || null;
    }

    quote(duration = this.duration, mode = this.mode, duo = this.duo) {
      const main = this.mainSelection(duration, mode);
      if (!main.valid) return { valid: false, message: main.message || this.c.unavailable_text };

      let items = [{ ...main.item }];
      let mainUnit = main.unit;
      let total = main.total;
      let compareTotal = this.baseUnit() * main.qty;

      if (!duo) {
        return {
          valid: true,
          total,
          compareTotal,
          mainTotal: total,
          mainCompareTotal: compareTotal,
          qty: main.qty,
          items
        };
      }

      if (!this.c.duo_live || !this.eligible()) {
        return { valid: false, message: this.c.duo_pending_text };
      }

      const o = main.offer || this.offerForDuration(duration) || this.onceOffer;
      const v = this.partnerVariantFor(main);
      if (!v?.available || !this.quantityValid(v, main.qty)) {
        return { valid: false, message: this.c.unavailable_text };
      }

      const partnerItem = { id: String(v.id), quantity: main.qty };
      let partnerUnit = v.price;

      if (mode === 'sub') {
        const p = v.plans.find(p => String(p.id) === String(o?.partner_plan_id));
        if (!p?.recurring) return { valid: false, message: this.c.duo_pending_text };
        partnerItem.selling_plan = String(p.id);
        partnerUnit = p.price;

        if (o?.duo_plan_id) {
          const own = main.variant.plans.find(p => String(p.id) === String(o.duo_plan_id));
          if (!own?.recurring) return { valid: false, message: this.c.duo_pending_text };
          items[0].selling_plan = String(own.id);
          mainUnit = own.price;
          total = mainUnit * main.qty;
        }
      } else if (v.requiresPlan) {
        return { valid: false, message: this.c.duo_pending_text };
      }

      items.push(partnerItem);
      total += partnerUnit * main.qty;
      compareTotal += v.price * main.qty;

      return {
        valid: true,
        total,
        compareTotal,
        mainTotal: mainUnit * main.qty,
        mainCompareTotal: this.baseUnit() * main.qty,
        qty: main.qty,
        items
      };
    }

    saving(reference, current) {
      const amount = Math.max(0, (Number(reference) || 0) - (Number(current) || 0));
      const percent = reference > 0 ? Math.max(0, (amount / reference) * 100) : 0;
      return { amount, percent };
    }

    percentText(n) {
      return new Intl.NumberFormat(this.data.locale || 'fr-FR', {
        maximumFractionDigits: 0
      }).format(n);
    }

    sachetCount(selection) {
      const detail = String(selection?.offer?.detail || '');
      const match = detail.match(/(\d+(?:[.,]\d+)?)\s*sachets?/i);
      if (match) {
        const count = Number(match[1].replace(',', '.'));
        if (Number.isFinite(count) && count > 0) return count;
      }
      return Math.max(1, (Number(selection?.qty) || 1) * 30);
    }

    sachetPriceText(selection) {
      if (!selection?.valid) return '';
      const count = this.sachetCount(selection);
      return `${this.money(selection.total / count)} par sachet`;
    }

    tokens(text, selection) {
      const base = this.baseUnit();
      const unit = selection?.unit || 0;
      const qty = selection?.qty || 1;
      const pct = base ? Math.max(0, (1 - unit / base) * 100) : 0;
      const values = {
        saving_percent: new Intl.NumberFormat(this.data.locale || 'fr-FR', { maximumFractionDigits: 1 }).format(pct),
        unit_price: this.money(unit),
        base_price: this.money(base),
        total_price: this.money(unit * qty)
      };

      return String(text || '').replace(/\{\{?\s*(saving_percent|unit_price|base_price|total_price)\s*\}?\}/g, (_, key) => values[key]);
    }

    render() {
      const c = this.c;
      const duoImage = this.data.duoImage
        ? `<img src="${escape(this.data.duoImage)}" alt="Les deux packs Newbloom" loading="lazy" width="500" height="500">`
        : `<div class="nbp-pair">${[this.main, this.partnerProduct].map(p => p?.image ? `<img src="${escape(p.image)}" alt="${escape(p.title)}" loading="lazy" width="300" height="400">` : '').join('')}</div>`;

      this.innerHTML = `
        <style>
          newbloom-offers .nbx-label{margin:0 0 10px;font:600 18px/1.25 Georgia,serif;font-style:italic;color:var(--nb-ink,#091c34)}
          newbloom-offers .nbx-duration-grid{display:grid;grid-template-columns:minmax(0,.82fr) minmax(0,1.18fr);gap:12px;margin-bottom:30px}
          newbloom-offers .nbx-duration{position:relative;width:100%;min-height:132px;border:1.5px solid #cfd3d8;border-radius:8px;background:#fff;color:var(--nb-ink,#091c34);padding:18px 20px;text-align:left}
          newbloom-offers .nbx-duration.is-selected{border:2px solid var(--nb-selected,#091c34);background:#fbf7f2}
          newbloom-offers .nbx-duration-title{display:block;font:600 25px/1.1 Georgia,serif;font-style:italic;margin-bottom:7px}
          newbloom-offers .nbx-duration-detail{display:block;color:#8a8493;font-size:13px;margin-bottom:7px}
          newbloom-offers .nbx-duration-copy{display:block;font-size:13px;line-height:1.35;max-width:360px}
          newbloom-offers .nbx-duration-unit{display:block;font-size:12px;font-weight:700;margin-top:9px}
          newbloom-offers .nbx-badge{position:absolute;right:16px;top:16px;border-radius:999px;background:#bcc8ff;color:#2c2343;padding:5px 11px;font-size:12px;line-height:1;font-weight:700}
          newbloom-offers .nbx-frequency-head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:10px}
          newbloom-offers .nbx-frequency-head .nbx-label{margin:0}
          newbloom-offers .nbx-frequency{display:grid;gap:10px}
          newbloom-offers .nbx-frequency-card{width:100%;border:1.5px solid #cfd3d8;border-radius:8px;background:#fff;color:var(--nb-ink,#091c34);padding:16px 20px;text-align:left}
          newbloom-offers .nbx-frequency-card.is-selected{border:2px solid var(--nb-selected,#091c34);background:#fbf7f2}
          newbloom-offers .nbx-frequency-top{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:center;gap:14px}
          newbloom-offers .nbx-frequency-title{font:600 22px/1.15 Georgia,serif;font-style:italic}
          newbloom-offers .nbx-price-stack{display:flex;align-items:baseline;justify-content:flex-end;gap:7px;flex-wrap:wrap;text-align:right}
          newbloom-offers .nbx-save{display:inline-block;border-radius:999px;background:#bcc8ff;color:#2c2343;padding:4px 10px;font-size:11px;font-weight:700}
          newbloom-offers .nbx-compare{color:#aaa4b0;text-decoration-thickness:1.5px;font-size:15px}
          newbloom-offers .nbx-total{font-size:20px;font-weight:700}
          newbloom-offers .nbx-per-pack{display:block;margin-top:4px;color:#6f6879;font-size:12px}
          newbloom-offers .nbx-subcopy{display:block;margin-top:4px;color:#8a8493;font-size:12px}
          newbloom-offers .nbx-frequency-bullets{display:grid;gap:6px;margin-top:10px;color:#8a8493;font-size:12px}
          newbloom-offers .nbx-frequency-bullet{display:grid;grid-template-columns:16px 1fr;gap:5px}
          newbloom-offers .nbp-partner{margin-top:24px}
          newbloom-offers .nbp-atc{border-radius:999px;gap:9px}
          newbloom-offers .nbx-atc-price{font-weight:800}
          newbloom-offers .nbx-atc-compare{opacity:.55;text-decoration-thickness:1.5px}
          @media(max-width:749px){
            newbloom-offers .nbx-duration-grid{grid-template-columns:1fr 1fr;gap:8px;margin-bottom:24px}
            newbloom-offers .nbx-duration{min-height:128px;padding:14px 13px}
            newbloom-offers .nbx-duration-title{font-size:21px}
            newbloom-offers .nbx-duration-detail{font-size:11px}
            newbloom-offers .nbx-duration-copy{font-size:11px}
            newbloom-offers .nbx-badge{right:9px;top:9px;padding:4px 8px;font-size:10px}
            newbloom-offers .nbx-frequency-card{padding:14px}
            newbloom-offers .nbx-frequency-title{font-size:19px}
            newbloom-offers .nbx-frequency-top{grid-template-columns:1fr auto;gap:8px}
            newbloom-offers .nbx-price-stack{gap:4px;max-width:180px}
            newbloom-offers .nbx-save{font-size:9px;padding:3px 7px}
            newbloom-offers .nbx-compare{font-size:12px}
            newbloom-offers .nbx-total{font-size:17px}
          }
        </style>

        <div class="nbx-quantity">
          <p class="nbx-label">Quantité</p>
          <div class="nbx-duration-grid" role="group" aria-label="Choisissez la durée">
            <button type="button" class="nbx-duration" data-duration="1" aria-pressed="false">
              <span class="nbx-duration-title">1 mois</span>
              <span class="nbx-duration-detail" data-duration-detail="1"></span>
              <span class="nbx-duration-copy">Permet de tester la tolérance du produit.</span>
              <span class="nbx-duration-unit" data-duration-unit="1"></span>
            </button>

            <button type="button" class="nbx-duration" data-duration="3" aria-pressed="false">
              <span class="nbx-badge" data-duration-badge="3" hidden></span>
              <span class="nbx-duration-title">3 mois</span>
              <span class="nbx-duration-detail" data-duration-detail="3"></span>
              <span class="nbx-duration-copy">Temps minimum nécessaire pour évaluer les effets du produit.</span>
              <span class="nbx-duration-unit" data-duration-unit="3"></span>
            </button>
          </div>
        </div>

        <div class="nbx-frequency-wrap">
          <div class="nbx-frequency-head">
            <p class="nbx-label">Fréquence de livraison</p>
            <button type="button" data-action="why" class="nbp-link">${escape(c.why_label)}</button>
          </div>

          <div class="nbx-frequency" role="group" aria-label="Choisissez votre fréquence de livraison">
            <button type="button" class="nbx-frequency-card" data-mode="once" aria-pressed="false">
              <span class="nbx-frequency-top">
                <span>
                  <span class="nbx-frequency-title">Achat unique</span>
                  <span class="nbx-per-pack" data-once-unit></span>
                </span>
                <span class="nbx-price-stack">
                  <span class="nbx-save" data-once-saving hidden></span>
                  <s class="nbx-compare" data-once-compare hidden></s>
                  <span class="nbx-total" data-once-total>—</span>
                </span>
              </span>
              <span class="nbx-frequency-bullets" data-once-bullets></span>
            </button>

            <button type="button" class="nbx-frequency-card" data-mode="sub" aria-pressed="false">
              <span class="nbx-frequency-top">
                <span>
                  <span class="nbx-frequency-title" data-sub-title>Livraison automatique</span>
                  <span class="nbx-subcopy">Zéro charge mentale. Sans engagement.</span>
                  <span class="nbx-per-pack" data-sub-unit></span>
                </span>
                <span class="nbx-price-stack">
                  <span class="nbx-save" data-sub-saving hidden></span>
                  <s class="nbx-compare" data-sub-compare hidden></s>
                  <span class="nbx-total" data-sub-total>—</span>
                </span>
              </span>
              <span class="nbx-frequency-bullets" data-sub-bullets></span>
              <span class="nbp-unavailable" data-sub-unavailable hidden>${escape(c.unavailable_text)}</span>
            </button>
          </div>
        </div>

        ${c.partner_enabled && this.partnerProduct?.id ? `
          <div class="nbp-partner" data-partner>
            <p class="nbp-question">${escape(c.partner_question)}</p>
            <div class="nbp-toggle" role="group" aria-label="Ajouter le pack partenaire">
              <button type="button" data-action="no">${escape(c.no_label)}</button>
              <button type="button" data-action="yes">${escape(c.yes_label)}</button>
            </div>
            <div class="nbp-duo" data-duo hidden>
              <div class="nbp-duo-image">${duoImage}</div>
              <div>
                <p class="nbp-duo-title">${escape(c.duo_title)}</p>
                <p>${escape(c.duo_text)}</p>
                <details class="nbp-info" data-tip>
                  <summary aria-label="Conditions de l’offre duo">i</summary>
                  <div class="nbp-tip" role="tooltip">${escape(c.duo_info)}</div>
                </details>
              </div>
            </div>
          </div>
        ` : ''}

        <p class="nbp-status" data-status role="status" aria-live="polite"></p>

        <button class="nbp-atc" type="button" data-action="add">
          <span>${escape(c.atc_label)}</span>
          <span>·</span>
          <span class="nbx-atc-price" data-total></span>
          <s class="nbx-atc-compare" data-compare-total hidden></s>
        </button>

        <p class="nbp-error" data-error role="alert" hidden></p>

        <dialog class="nbp-dialog" aria-labelledby="nbp-dialog-${escape(this.data.section)}">
          <button class="nbp-close" type="button" data-action="close" aria-label="Fermer">×</button>
          ${this.data.modalImage ? `<img class="nbp-modal-img" src="${escape(this.data.modalImage)}" alt="Routine Newbloom" loading="lazy" width="600" height="400">` : ''}
          <div class="nbp-modal-body">
            <h2 id="nbp-dialog-${escape(this.data.section)}">${escape(c.modal_title)}</h2>
            <ul>${lines(c.modal_bullets).map(line => {
              const [title, ...text] = line.split('|');
              return `<li><span aria-hidden="true">✓</span><div><strong>${escape(title)}</strong>${text.length ? ' ' + escape(text.join('|')) : ''}</div></li>`;
            }).join('')}</ul>
            <button type="button" class="nbp-modal-button" data-action="close">${escape(c.modal_button)}</button>
          </div>
        </dialog>
      `;
    }

    setPriceCard(mode, q) {
      const totalEl = this.querySelector(`[data-${mode}-total]`);
      const compareEl = this.querySelector(`[data-${mode}-compare]`);
      const savingEl = this.querySelector(`[data-${mode}-saving]`);
      const unitEl = this.querySelector(`[data-${mode}-unit]`);
      const card = this.querySelector(`[data-mode="${mode === 'once' ? 'once' : 'sub'}"]`);

      if (!q.valid) {
        totalEl.textContent = '—';
        compareEl.hidden = true;
        savingEl.hidden = true;
        unitEl.textContent = this.c.unavailable_text;
        card.disabled = true;
        return;
      }

      card.disabled = !!this.busy;
      totalEl.textContent = this.money(q.total);
      unitEl.textContent = `${this.money(q.mainTotal / q.qty)} / paquet`;

      const s = this.saving(q.mainCompareTotal, q.mainTotal);
      const hasSaving = s.amount > 0.5;

      compareEl.hidden = !hasSaving;
      savingEl.hidden = !hasSaving;

      if (hasSaving) {
        compareEl.textContent = this.money(q.mainCompareTotal);
        savingEl.textContent = `${this.money(s.amount)} économisés`;
      }
    }

    refresh() {
      const currentMain = this.mainSelection();
      if (!currentMain.valid) return;

      const oneMonthCurrentMode = this.quote(1, this.mode, false);
      const threeMonthCurrentMode = this.quote(3, this.mode, false);

      for (const button of this.querySelectorAll('[data-duration]')) {
        const d = Number(button.dataset.duration);
        const qCurrent = d === 3 ? threeMonthCurrentMode : oneMonthCurrentMode;
        const altMode = this.mode === 'sub' ? 'once' : 'sub';
        const qAlt = this.quote(d, altMode, false);
        const qDisplay = qCurrent.valid ? qCurrent : qAlt;
        const active = d === this.duration;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        button.disabled = (!qCurrent.valid && !qAlt.valid) || !!this.busy;

        const detail = this.querySelector(`[data-duration-detail="${d}"]`);
        const unit = this.querySelector(`[data-duration-unit="${d}"]`);
        const source = d === 3 ? this.quarterOffer : (this.monthOffer || this.onceOffer);
        if (detail) detail.textContent = source?.detail || (d === 3 ? '3 boîtes' : '1 boîte');
        if (unit) unit.textContent = qDisplay.valid ? `${this.money(qDisplay.mainTotal / qDisplay.qty)} / paquet` : this.c.unavailable_text;
      }

      const badge = this.querySelector('[data-duration-badge="3"]');
      if (badge) {
        if (oneMonthCurrentMode.valid && threeMonthCurrentMode.valid && oneMonthCurrentMode.mainTotal > 0) {
          const ref = oneMonthCurrentMode.mainTotal * 3;
          const s = this.saving(ref, threeMonthCurrentMode.mainTotal);
          badge.hidden = s.amount <= 0.5;
          if (!badge.hidden) badge.textContent = `-${this.percentText(s.percent)}%`;
        } else {
          badge.hidden = true;
        }
      }

      const onceQ = this.quote(this.duration, 'once', false);
      const subQ = this.quote(this.duration, 'sub', false);
      this.setPriceCard('once', onceQ);
      this.setPriceCard('sub', subQ);

      const onceCard = this.querySelector('[data-mode="once"]');
      const subCard = this.querySelector('[data-mode="sub"]');
      onceCard.classList.toggle('is-selected', this.mode === 'once');
      subCard.classList.toggle('is-selected', this.mode === 'sub');
      onceCard.setAttribute('aria-pressed', String(this.mode === 'once'));
      subCard.setAttribute('aria-pressed', String(this.mode === 'sub'));

      const subTitle = this.querySelector('[data-sub-title]');
      subTitle.textContent = this.duration === 3 ? 'Livraison tous les 3 mois' : 'Livraison chaque mois';

      const onceSelection = this.mainSelection(this.duration, 'once');
      const subSelection = this.mainSelection(this.duration, 'sub');
      const onceBullets = this.querySelector('[data-once-bullets]');
      const subBullets = this.querySelector('[data-sub-bullets]');
      const subUnavailable = this.querySelector('[data-sub-unavailable]');

      if (onceBullets) {
        onceBullets.innerHTML = onceSelection.valid ? `
          <span class="nbx-frequency-bullet">
            <span aria-hidden="true">✓</span>
            <span>${escape(this.sachetPriceText(onceSelection))}</span>
          </span>
        ` : '';
      }

      if (subSelection.valid) {
        const list = lines(subSelection.offer?.bullets);
        const sachetBullet = `
          <span class="nbx-frequency-bullet">
            <span aria-hidden="true">✓</span>
            <span>${escape(this.sachetPriceText(subSelection))}</span>
          </span>
        `;
        const configuredBullets = list.map(t => `
          <span class="nbx-frequency-bullet">
            <span aria-hidden="true">✓</span>
            <span>${escape(this.tokens(t, subSelection))}</span>
          </span>
        `).join('');
        subBullets.innerHTML = sachetBullet + configuredBullets;
        subUnavailable.hidden = true;
      } else {
        subBullets.innerHTML = '';
        subUnavailable.hidden = false;
      }

      const region = this.querySelector('[data-partner]');
      if (region) {
        region.hidden = !this.eligible();
        this.querySelector('[data-duo]').hidden = !this.duo;
        for (const b of region.querySelectorAll('[data-action]')) {
          b.setAttribute('aria-pressed', String((b.dataset.action === 'yes') === this.duo));
          b.disabled = !!this.busy;
        }
      }

      this.currentQuote = this.quote();
      const total = this.querySelector('[data-total]');
      const compare = this.querySelector('[data-compare-total]');
      const status = this.querySelector('[data-status]');
      const addButton = this.querySelector('[data-action="add"]');

      if (this.currentQuote.valid) {
        total.textContent = this.money(this.currentQuote.total);
        const hasCompare = this.currentQuote.compareTotal > this.currentQuote.total + 0.5;
        compare.hidden = !hasCompare;
        if (hasCompare) compare.textContent = this.money(this.currentQuote.compareTotal);
        status.textContent = '';
      } else {
        total.textContent = '';
        compare.hidden = true;
        status.textContent = this.currentQuote.message || this.c.unavailable_text;
      }

      addButton.disabled = !this.currentQuote.valid || !!this.busy;
      this.querySelector('[data-error]').hidden = true;
    }

    mount() {
      const target = document.querySelector(this.c.target_selector || '.product__info-container');
      if (!target) throw new Error('Emplacement de la fiche produit introuvable.');

      const wrapper = this.closest('.shopify-section') || this;
      if (target.querySelector('newbloom-offers') && target.querySelector('newbloom-offers') !== this) {
        throw new Error('Un module Offres Newbloom est déjà présent pour ce produit.');
      }

      const anchor = target.querySelector(this.c.anchor_selector || '.newbloom-benefits-card');
      const form = target.querySelector('product-form') || target.querySelector('form[action*="/cart/add"]');

      if (anchor) anchor.insertAdjacentElement('afterend', wrapper);
      else if (form) form.before(wrapper);
      else target.append(wrapper);

      this.hiddenElements = [];
      const hide = el => {
        if (!el || wrapper.contains(el) || el.contains(wrapper) || this.hiddenElements.some(x => x.el === el)) return;
        this.hiddenElements.push({
          el,
          style: el.style.getPropertyValue('display'),
          priority: el.style.getPropertyPriority('display')
        });
        el.style.setProperty('display', 'none', 'important');
      };

      this.hideOld = () => {
        target.querySelectorAll(
          this.c.hide_selector || 'variant-selects,variant-radios,.product-form__quantity,.product-form__input--quantity,product-form,form[action*="/cart/add"],kaching-bundles-block,.kaching-bundles'
        ).forEach(hide);
        document.querySelectorAll('[class*="ai-sticky-add-to-cart"],[class*="sticky-atc"],sticky-add-to-cart').forEach(hide);
      };

      this.hideOld();
      this.observer = new MutationObserver(() => this.hideOld());
      this.observer.observe(target, { childList: true, subtree: true });

      document.addEventListener('submit', e => {
        if (e.target.matches('form[action*="/cart/add"]') && target.contains(e.target) && !this.contains(e.target)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.add();
        }
      }, { capture: true, signal: this.abort.signal });
    }

    async add() {
      if (this.busy) return;

      const quote = this.quote();
      if (!quote.valid) {
        this.refresh();
        return;
      }

      this.busy = true;
      this.refresh();

      const button = this.querySelector('[data-action="add"]');
      button.setAttribute('aria-busy', 'true');
      const error = this.querySelector('[data-error]');

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: quote.items })
        });

        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'Ajout impossible. Vérifiez la disponibilité du produit.');
        }

        if (!Array.isArray(result.items) || result.items.length !== quote.items.length) {
          throw new Error('Vérifiez votre panier avant de réessayer. La réponse Shopify est incomplète.');
        }

        window.location.assign(root + 'cart');
      } catch (e) {
        this.busy = false;
        this.refresh();
        error.textContent = e instanceof TypeError
          ? 'Connexion interrompue : vérifiez votre panier avant de réessayer.'
          : e.message;
        error.hidden = false;
        button.removeAttribute('aria-busy');
      }
    }

    cleanup() {
      this.abort?.abort();
      this.observer?.disconnect();
      if (this.dialog?.open) {
        this.dialog.close();
        document.body.style.overflow = this.previousOverflow ?? '';
      }
      for (const x of this.hiddenElements || []) {
        if (x.style) x.el.style.setProperty('display', x.style, x.priority);
        else x.el.style.removeProperty('display');
      }
      this.hiddenElements = [];
    }
  }

  customElements.define('newbloom-offers', NewbloomOffers);
})();

  } catch(e) { console.error(e); }
})();
})();
